import React, {useEffect, useState} from 'react';
import i18n from '../../i18n';
import Button from '@material-ui/core/Button';
import Divider from "@material-ui/core/Divider";
import Icon from '@material-ui/core/Icon';
import FormField from '../Form/FormField';
import Grid from '@material-ui/core/Grid/Grid';
import DeleteButton from '../Form/DeleteButton';
import FormSelect from '../Form/FormSelect';
import FormAutocompleteGQL from '../Form/FormAutocompleteGQL';
import {getMutationName, getSelectOptionEntity} from '../Form/utils';
import userQueries from "../../queries/userQueries";
import swal from "sweetalert";
import professionMutations from "../../mutations/professionMutations";
import {Typography} from "@material-ui/core";
import {blue,green} from "@material-ui/core/colors";
import _ from 'lodash';
import FormFieldDecimal from "../Formater/FormFieldDecimal";
import FormFieldMask from "../Formater/FormFieldMask";

const saveNewProfession = async (profession) => {
    const mutation = professionMutations.createProfession;
    const queryName = getMutationName(mutation);
    const variables = {name:profession};
    if(profession) {
        const {data: result} = await window.apolloClient.mutate(
            { mutation, variables: variables, errorPolicy: "all"  }
        ).catch((e) => { console.log('graphQLErrors', e ) });
        return result[queryName];
    } else {
        return null;
    }
}

const dialogNewProfession = async (profession) => {
    return swal({
        title: profession,
        text: i18n.get('personnel.dialog.new_profession'),
        icon: 'info',
        buttons: {
            cancel: i18n.get('personnel.dialog.cancel'),
            confirm: {
                text:i18n.get('personnel.dialog.add'),
                closeModal: false,
            },
        },
        closeOnClickOutside: false,
        closeOnEsc: false,
    }).then( async (confirmed) => {
        if(confirmed){
            return await saveNewProfession(profession);
        }
    });
}

const FormFields = (props)=> {
    const{
        classes,
        errors,
        handleBlur,
        handleChange,
        isSubmitting,
        setFieldValue,
        touched,
        values
    } = props;

    const breakTimes = [0,0.25,0.5,0.75,1.0,1.25,1.5];
    const defaultWorkingTimes = {from: '07:00', to: '17:00', break: 90};
    const fridayWorkingTimes = {from: '07:00', to: '14:00', break: 60};
    const weekendWorkingTimes = {from:'00:00',to:'00:00',break:0};
    const defaultWorkingDays = [
        defaultWorkingTimes,
        defaultWorkingTimes,
        defaultWorkingTimes,
        defaultWorkingTimes,
        fridayWorkingTimes,
        weekendWorkingTimes,
        weekendWorkingTimes
    ];

    const summerTimes = (typeof values.working_time_summer === 'string')
        && JSON.parse( values.working_time_summer );
    const winterTimes = (typeof values.working_time_winter === 'string')
        && JSON.parse( values.working_time_winter );

    const [remuneration,setRemuneration] = useState(values.type_of_remuneration);
    const [professions,setProfessions] = useState(values.professions || null);
    const [professionId,setProfessionId] = useState( values.profession_id || '');
    const [workingTimeSummer,setWorkingTimeSummer] = useState(summerTimes || _.cloneDeep(defaultWorkingDays));
    const [workingTimeWinter,setWorkingTimeWinter] = useState(winterTimes || _.cloneDeep(defaultWorkingDays));

    const changeWorkingTime = (type, weekday,time,value) => {
        let workingTime = type === 'summer' ? workingTimeSummer : workingTimeWinter;
        workingTime[weekday] = {...workingTime[weekday],[time]:value }
        type ==='summer'
            ? setWorkingTimeSummer(workingTime)
            : setWorkingTimeWinter(workingTime);
        setFieldValue('working_time_'+ type, workingTime);
    }

    const handleNewProfession = (profession) => {
        dialogNewProfession(profession).then((res) => {
            if(res) {
                setProfessions([...professions, res]);
                setProfessionId(res.id);
                setFieldValue('profession_id',res.id);
                return swal(profession, i18n.get('personnel.dialog.profession_saved'), "success");
            }
        })
    }

    useEffect(() => {
        if(remuneration !== 'wage'){
            setFieldValue('working_time_summer',null);
            setFieldValue('working_time_winter',null);
        } else {
            setFieldValue('working_time_summer',workingTimeSummer);
            setFieldValue('working_time_winter',workingTimeWinter);
        }
    },[remuneration])

    return (
        <React.Fragment>

            <Grid container spacing={8}>

                <Grid item xs={12} sm={6} lg={3}>
                    <FormField
                        type="text"
                        name="first_name"
                        label={i18n.get('personnel.form.first_name')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.first_name}
                        error={errors.first_name}
                        touched={touched.first_name}
                        maxLength={255}
                        autoComplete={'off'}
                    />
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                    <FormField
                        type="text"
                        name="last_name"
                        label={i18n.get('personnel.form.last_name')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.last_name}
                        error={errors.last_name}
                        touched={touched.last_name}
                        maxLength={255}
                        autoComplete={'off'}
                    />
                </Grid>

                <Grid item xs={12} sm={6} lg={3}>
                    <FormField
                        type="text"
                        name="birth_name"
                        label={i18n.get('personnel.form.birth_name')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.birth_name}
                        error={errors.birth_name}
                        touched={touched.birth_name}
                        maxLength={255}
                        autoComplete={'off'}
                    />
                </Grid>

                <Grid item xs={12} sm={6} lg={3}>
                    <FormField
                        type="date"
                        name="birth_date"
                        label={i18n.get('personnel.form.birth_date')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.birth_date}
                        touched={touched.birth_date}
                        value={values.birth_date ? values.birth_date.substring(0, 10) : ''}
                        InputLabelProps={{shrink: true}}
                    />
                </Grid>

                <Grid item xs={12} sm={6} lg={3}>
                    <FormField
                        type="text"
                        name="number"
                        label={i18n.get('personnel.form.number')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.number}
                        error={errors.number}
                        touched={touched.number}
                        maxLength={255}
                        autoComplete={'off'}
                    />
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                    <FormSelect
                        type="text"
                        name="profession_id"
                        label={i18n.get('personnel.form.profession')}
                        error={errors.profession_id}
                        touched={touched.profession_id}
                        onChange={e => {
                            let id = e ? e.value : null;
                            setProfessionId(id);
                            setFieldValue('profession_id', id);
                        }}
                        onBlur={handleBlur}
                        onCreated={(option) => handleNewProfession(option)}
                        options={professions.map(profession => {
                            return {label:profession.name,value:profession.id}
                        })}
                        value={professionId}
                        isClearable={true}
                        creatable={true}
                        newOptionLabel={i18n.get('personnel.form.new_profession')}
                    />
                </Grid>

                <Grid item xs={12} sm={6} lg={3}>
                    <FormField
                        type="date"
                        name="entry_date"
                        label={i18n.get('personnel.form.entry_date')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.entry_date}
                        touched={touched.entry_date}
                        value={values.entry_date ? values.entry_date.substring(0, 10) : ''}
                        InputLabelProps={{shrink: true}}
                    />
                </Grid>

                <Grid item xs={12} sm={6} lg={3}>
                    <FormField
                        type="date"
                        name="exit_date"
                        label={i18n.get('personnel.form.exit_date')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.exit_date}
                        touched={touched.exit_date}
                        value={values.exit_date ? values.exit_date.substring(0, 10) : ''}
                        InputLabelProps={{shrink: true}}
                    />
                </Grid>


                <Grid item xs={12} sm={4}>
                    <FormAutocompleteGQL
                        query={userQueries.findUsers}
                        labelName={'name'}
                        valueName={'id'}
                        name={'user_id'}
                        label={i18n.get('personnel.form.linked_user')}
                        error={errors.user_id}
                        touched={touched.user_id}
                        onChange={e => {
                            setFieldValue('user', e && e.entity ? e.entity : null);
                            setFieldValue('user_id', e && e.entity ? e.entity.id : '');
                        }}
                        defaultOptions
                        onBlur={handleBlur}
                        defaultValue={values.user && getSelectOptionEntity(values.user)}
                        isClearable={true}
                        filter={values.assigned_users && {id:values.assigned_users}}
                    />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <FormSelect
                        type="text"
                        name="type_of_remuneration"
                        label={i18n.get('personnel.form.type_of_remuneration')}
                        options={['salary','wage'].map(name => { return { label:i18n.get('personnel.form.remuneration_'+ name),value:name } })}
                        onChange={option => {
                            setFieldValue('type_of_remuneration', option.value);
                            setRemuneration(option.value);
                        }}
                        value={remuneration}
                    />
                </Grid>


                <Grid item xs={12} sm={4}>
                    <FormField
                        type="text"
                        name="remuneration_amount"
                        label={i18n.get('personnel.form.amount')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.remuneration_amount}
                        error={errors.remuneration_amount}
                        touched={touched.remuneration_amount}
                        autoComplete={'off'}
                        suffix={' €'}
                        InputProps={{
                            inputComponent: FormFieldDecimal,
                        }}
                    />
                </Grid>

            </Grid>

            {remuneration === 'wage' && (
                <React.Fragment>
                    <Divider className={classes.divider} />
                    <Grid container spacing={8}>
                        <Grid item xs={12}>
                            <Typography variant={'h6'} color={'primary'}>
                                {i18n.get('personnel.form.working_times')}
                            </Typography>
                            <Typography variant={'caption'} className={classes.vSpace} style={{color:'rgba(0,0,0,0.5)'}}>
                                {i18n.get('personnel.form.hint')}
                            </Typography>
                        </Grid>
                        <Grid item sm={12} md={6} container spacing={8} style={{borderLeft:'1px solid',borderLeftColor:green[600]}}>
                            <Grid item xs={12}>
                                <Typography className={classes.green} style={{marginBottom:10,fontSize:'1rem'}}>
                                    {i18n.get('personnel.form.summer')}
                                </Typography>
                            </Grid>
                            {workingTimeSummer && workingTimeSummer.map((data,weekday) =>
                                <Grid item xs={12} key={'summer_' + weekday} container spacing={8} style={{display: weekday > 4 && 'none'}}>
                                    {weekday > 0 &&(
                                        <Grid item xs={12} className={classes.dividerHide}>
                                            <Divider className={classes.divider} style={{backgroundColor:green[600]}}/>
                                        </Grid>
                                    )}
                                    <Grid item xs={12} sm={4}>
                                        <FormField
                                            type="time"
                                            name={`working_time_summer_${weekday}_from`}
                                            label={i18n.get('personnel.form.from_' + weekday )}
                                            onChange={e => {
                                                //console.log(e.target.value);
                                                changeWorkingTime('summer', `${weekday}`,'from', e.target.value );
                                            }}
                                            value={ workingTimeSummer[weekday].from }
                                            InputLabelProps={{shrink: true}}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormField
                                            type="time"
                                            name={`working_time_summer_${weekday}_to`}
                                            label={i18n.get('personnel.form.to')}
                                            onChange={e => {
                                                changeWorkingTime('summer', `${weekday}`,'to', e.target.value );
                                            }}
                                            value={ workingTimeSummer[weekday].to }
                                            InputLabelProps={{shrink: true}}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormSelect
                                            type="text"
                                            name={`working_time_summer_${weekday}_break`}
                                            label={i18n.get('personnel.form.break')}
                                            options={breakTimes.map( val => { return { label:val + 'h',value: (val*60) } } )}
                                            onChange={e => {
                                                changeWorkingTime('summer', `${weekday}`,'break', e.value );
                                            }}
                                            value={ workingTimeSummer[weekday].break }
                                        />
                                    </Grid>
                                </Grid>
                            ).filter((data,weekDay) => weekDay <= 4)}
                        </Grid>
                        <Grid item sm={12} md={6} container spacing={8} style={{borderLeft:'1px solid',borderLeftColor:blue[600]}}>
                            <Grid item xs={12}>
                                <Typography className={classes.blue} style={{marginBottom:10,fontSize:'1rem'}}>
                                    {i18n.get('personnel.form.winter')}
                                </Typography>
                            </Grid>
                            {workingTimeWinter.map((data,weekday) =>
                                <Grid item xs={12} key={'winter_'+ weekday} container spacing={8} style={{display: weekday > 4 && 'none'}}>
                                    {weekday > 0 && (
                                        <Grid item xs={12} className={classes.dividerHide}>
                                            <Divider className={classes.divider} style={{backgroundColor:blue[600]}}/>
                                        </Grid>
                                    )}
                                    <Grid item xs={12} sm={4} >
                                        <FormField
                                            type="time"
                                            name={`working_time_winter_${weekday}_from`}
                                            label={i18n.get('personnel.form.from_' + weekday )}
                                            onChange={e => {
                                                changeWorkingTime('winter', `${weekday}`,'from', e.target.value );
                                            }}
                                            value={ workingTimeWinter[weekday].from }
                                            InputLabelProps={{shrink: true}}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormField
                                            type="time"
                                            name={`working_time_winter_${weekday}_to`}
                                            label={i18n.get('personnel.form.to')}
                                            onChange={e => {
                                                changeWorkingTime('winter', `${weekday}`,'to', e.target.value );
                                            }}
                                            value={ workingTimeWinter[weekday].to }
                                            InputLabelProps={{shrink: true}}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormSelect
                                            type="text"
                                            name={`working_time_winter_${weekday}_break`}
                                            label={i18n.get('personnel.form.break')}
                                            options={breakTimes.map( val => { return { label:val + 'h',value: (val*60) } } )}
                                            onChange={e => {
                                                changeWorkingTime('winter', `${weekday}`,'break', e.value );
                                            }}
                                            value={ workingTimeWinter[weekday].break }
                                        />
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </React.Fragment>
            )}

            <Divider className={classes.divider} />
            <Grid container spacing={8}>
                <Grid item xs={12}>
                    <Typography variant={'h6'} color={'primary'}>
                        {i18n.get('personnel.form.banking_details')}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        type="text"
                        name="iban"
                        label={'IBAN'}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.iban}
                        error={errors.iban}
                        touched={touched.iban}
                        autoComplete={'off'}
                        mask={'iban'}
                        InputProps={{
                            inputComponent: FormFieldMask,
                        }}

                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        type="text"
                        name="bic"
                        label={'BIC'}
                        className={classes.test}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.bic}
                        error={errors.bic}
                        touched={touched.bic}
                        autoComplete={'off'}
                        mask={'bic'}
                        InputProps={{
                            inputComponent: FormFieldMask,
                        }}
                    />
                </Grid>
            </Grid>

            <Divider className={classes.divider} />

            <Grid container spacing={8}>
                <Grid item xs={12} sm={6} container spacing={8}>
                    <Grid item xs={12}>
                        <Typography variant={'h6'} color={'primary'}>
                            {i18n.get('personnel.form.expense_allowance')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <FormField
                            type="text"
                            name="allowance"
                            label={
                                i18n.get('personnel.form.accommodation')
                                + ' & '
                                + i18n.get('personnel.form.meal_allowance')
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.allowance}
                            error={errors.allowance}
                            touched={touched.allowance}
                            autoComplete={'off'}
                            suffix={' €/h'}
                            InputProps={{
                                inputComponent: FormFieldDecimal,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant={'subtitle1'}>
                            {i18n.get('personnel.form.meal_allowance') + ': '}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} xl={6}>
                        <FormField
                            type="text"
                            name="meal_allowance_1"
                            label={i18n.get('personnel.form.meal_allowance') + ' 1'}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.meal_allowance_1}
                            error={errors.meal_allowance_1}
                            touched={touched.meal_allowance_1}
                            autoComplete={'off'}
                            suffix={' €/Tag'}
                            InputProps={{
                                inputComponent: FormFieldDecimal,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} xl={6}>
                        <FormField
                            type="text"
                            name="meal_allowance_2"
                            label={i18n.get('personnel.form.meal_allowance') + ' 2'}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.meal_allowance_2}
                            error={errors.meal_allowance_2}
                            touched={touched.meal_allowance_2}
                            autoComplete={'off'}
                            suffix={' €/Tag'}
                            InputProps={{
                                inputComponent: FormFieldDecimal,
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={6} container spacing={8}>
                    <Grid item xs={12}>
                        <Typography variant={'h6'} color={'primary'}>
                            {i18n.get('personnel.form.travel_expense_allowance')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <FormField
                            type="text"
                            name="total_reimbursement"
                            label={i18n.get('personnel.form.total_cost_reimbursement')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.total_reimbursement}
                            error={errors.total_reimbursement}
                            touched={touched.total_reimbursement}
                            autoComplete={'off'}
                            suffix={' €'}
                            InputProps={{
                                inputComponent: FormFieldDecimal,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant={'subtitle1'}>
                            {i18n.get('personnel.form.mileage_accounting') + ': '}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} xl={6}>
                        <FormField
                            type="text"
                            name="amount_per_km"
                            label={i18n.get('personnel.form.amount_per_km')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.amount_per_km}
                            error={errors.amount_per_km}
                            touched={touched.amount_per_km}
                            autoComplete={'off'}
                            suffix={' €/km'}
                            InputProps={{
                                inputComponent: FormFieldDecimal,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} xl={6}>
                        <FormField
                            type="text"
                            name="distance"
                            label={i18n.get('personnel.form.kilometre')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.distance}
                            error={errors.distance}
                            touched={touched.distance}
                            autoComplete={'off'}
                            suffix={' km'}
                            InputProps={{
                                inputComponent: FormFieldDecimal,
                            }}
                        />
                    </Grid>
                </Grid>
            </Grid>

            {props.children}

            <Grid container spacing={24} justify="space-between"
                  alignItems="center"
                  style={{paddingTop: 8}}>
                <Grid item>
                    {values.id > 0 && (
                        <DeleteButton
                            disabled={isSubmitting}
                            href={`/personnel/${values.id}`}
                            confirmMessage={i18n.get(
                                'contacts.confirm_message')}
                            successMessage={i18n.get(
                                'contacts.delete_success_message')}
                            handleSuccess={() => {
                                window.location.href = `/personnel`;
                            }}
                        />
                    )}
                </Grid>
                <Grid item>
                    <Button size="small"
                            variant="contained"
                            color="primary"
                            type="submit"
                            disabled={isSubmitting}
                    >
                        <Icon fontSize="small">save</Icon>
                        &nbsp;
                        {i18n.get('personnel.actions.save')}
                    </Button>
                </Grid>
            </Grid>

        </React.Fragment>
    )
};

export default FormFields;
